import React, { useEffect, useState } from "react";
import product from "../../assets/product.png";
import calender from "../../assets/calender.png";
import done from "../../assets/done.png";
import statusIcon from "../../assets/orders/status.png";
import guatantee from "../../assets/orders/guatantee.png";
import { Button, message, Modal, Radio, Space } from "antd";
import Preparing from "./Preparing";
import Assigned from "./Assigned";
import Gettingready from "./Gettingready";
import Ontheway from "./Ontheway";
import Arrived from "./Arrived";
import Pricing from "./Pricing";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderById } from "../../redux/ShowOrderIdSlice";
import Payment from "./Payment";
import { fetchUser } from "../../redux/getUserSlice";
import { useTranslation } from "react-i18next";
import { createAgentChat } from "../../redux/createChatAgentSlice";
import { useNavigate } from "react-router-dom";
import { updateOrderFunction } from "../../redux/orderUpdateSlice";

const ServiceRequest = ({
  idOrder,
  image,
  date,
  time,
  addressOrder,
  description,
  uploadedImages,
  status,
  dateCreated,
  timeCreated,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCancel, setIsModalCancel] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);

  const dispatch = useDispatch();
  const { order, error } = useSelector((state) => state.order);
  const [orderStatus, setOrderStatus] = useState("on_way");

  const showModal = async () => {
    await dispatch(fetchOrderById(idOrder));
    setCurrentOrder(order);
    if (order?.status === "acceptperview") {
      setIsModalOpen(true);
    } else if (order?.agent_id !== null) {
      setOrderStatus("Assigned");
      setIsModalOpen(true);
    } else {
      setIsModalOpen(true);
    }

    // setIsModalOpen(true);
  };

  // if(order?.agent_id !== null){
  //   setOrderStatus("Assigned")
  // }
  // const showModal = (status) => {
  //   setOrderStatus(status);
  //   setIsModalOpen(true);
  // };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModalCancel = () => {
    setIsModalCancel(true);
  };
  const handleOkCancel = () => {
    setIsModalCancel(false);
  };
  const handleCancelCancel = () => {
    setIsModalCancel(false);
  };

  // const formattedTime = new Date(order?.updated_at).toLocaleTimeString([], {
  //   hour: "2-digit",
  //   minute: "2-digit",
  // });

  const formatDateTime = (dateString) => {
    const dateObject = new Date(dateString);
    const day = String(dateObject.getDate()).padStart(2, "0");
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const year = dateObject.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const hours = String(dateObject.getHours()).padStart(2, "0");
    const minutes = String(dateObject.getMinutes()).padStart(2, "0");

    const formattedTime = `${hours}:${minutes}`;

    return { formattedDate, formattedTime };
  };

  const { formattedDate, formattedTime } = formatDateTime(order?.updated_at);

  const { getUser } = useSelector((state) => state.getUser);

  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);

  const renderModalContent = () => {
    if (order?.status === "approved") {
      return (
        <Gettingready
          image={`https://service.samoolah.com/${order?.category?.icon}`}
          idOrder={order?.id}
          idAgent={order?.agent?.id}
          AgentImage={`https://service.samoolah.com/${order?.agent?.image}`}
          agentName={order?.agent?.name}
          agentLastName={order?.agent?.last_name}
          date={order?.date}
          time={order?.time}
          addresss={order?.address}
          description={order?.description}
          statuss={language == "en" ? "Preparing" : "التحضير"}
          images={order?.uploaded_images}
          updated_at={formattedTime}
          updated_atDate={formattedDate}
        />
      );
    } else if (order?.status === "on_way") {
      return (
        <Ontheway
          image={`https://service.samoolah.com/${order?.category?.icon}`}
          idOrder={order?.id}
          idAgent={order?.agent?.id}
          AgentImage={`https://service.samoolah.com/${order?.agent?.image}`}
          agentName={order?.agent?.name}
          agentLastName={order?.agent?.last_name}
          date={order?.date}
          time={order?.time}
          addresss={order?.address}
          description={order?.description}
          statuss={language == "en" ? "On the way" : "في الطريق"}
          images={order?.uploaded_images}
          latitude={getUser?.latitude}
          longitude={getUser?.longitude}
          agentLocationLatitude={order?.agent?.longitude}
          agentLocationLongitude={order?.agent?.latitude}
          // agentLocationLatitude={30.063024}
          // agentLocationLongitude={31.503247}
          updated_at={formattedTime}
          updated_atDate={formattedDate}
        />
      );
    } else if (order?.status === "arrived") {
      return (
        <Arrived
          image={`https://service.samoolah.com/${order?.category?.icon}`}
          idOrder={order?.id}
          idAgent={order?.agent?.id}
          AgentImage={`https://service.samoolah.com/${order?.agent?.image}`}
          agentName={order?.agent?.name}
          agentLastName={order?.agent?.last_name}
          date={order?.date}
          time={order?.time}
          addresss={order?.address}
          description={order?.description}
          statuss={language == "en" ? "Arrived" : "وصل"}
          images={order?.uploaded_images}
          latitude={getUser?.latitude}
          longitude={getUser?.longitude}
          agentLocationLatitude={order?.agent?.new_latitude}
          agentLocationLongitude={order?.agent?.new_longitude}
          updated_at={formattedTime}
          updated_atDate={formattedDate}
        />
      );
    } else if (
      order?.status === "scaned_qr" ||
      order?.status === "cost_arrangement"
    ) {
      return (
        <Pricing
          image={`https://service.samoolah.com/${order?.category?.icon}`}
          idOrder={order?.id}
          agentName={order?.agent?.name}
          agentLastName={order?.agent?.last_name}
          AgentImage={`https://service.samoolah.com/${order?.agent?.image}`}
          date={order?.date}
          time={order?.time}
          addresss={order?.address}
          description={order?.description}
          statuss={language == "en" ? "Cost arrangement" : "ترتيب التكلفة"}
          stat={order?.status}
          images={order?.uploaded_images}
          clear_price={order?.clear_price}
          agent_description={order?.agent_description}
          updated_at={formattedTime}
          updated_atDate={formattedDate}
        />
      );
    } else if (order?.status === "acceptperview") {
      return (
        <Payment
          image={`https://service.samoolah.com/${order?.category?.icon}`}
          idOrder={order?.id}
          agentName={order?.agent?.name}
          AgentImage={`https://service.samoolah.com/${order?.agent?.image}`}
          date={order?.date}
          time={order?.time}
          addresss={order?.address}
          description={order?.description}
          statuss={language == "en" ? "Accept perview" : "تم قبول العرض"}
          images={order?.uploaded_images}
          clear_price={order?.clear_price}
          payment_method={order?.payment_method}
          updated_at={formattedTime}
          updated_atDate={formattedDate}
        />
      );
    }
  };

  const [value, setValue] = useState(1);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const [createData, setCreateData] = useState({
    order_id: order?.id,
    agent_id: order?.agent?.id,
  });

  const navigate = useNavigate();

  const handleChatLinkClick = () => {
    navigate(`/chat/${order?.id}`);
    dispatch(createAgentChat(createData));
  };

  return (
    <div>
      <div className="bg-white shadow-2xl rounded-2xl mt-4 p-4">
        <div className="flex justify-between max-lg:items-start">
          <div className="lg:flex items-center">
            <div className="bg-[#FCFBFA] p-3 rounded-2xl max-lg:w-[110px]">
              <img src={image} className="w-[80px] " />
            </div>
            <p className={`${
                language == "en" ? "ml-3" : "mr-3"
              } text-[#737E91] font-semibold max-lg:mt-3`}>
            {t("Order number")}
              <span className="text-[#283D63] font-semibold">#{idOrder}</span>
              <div className="flex items-center mt-3">
                <img src={calender} className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">
                  {date} | {time}
                </p>
              </div>
              <div className="flex items-center mt-3">
                <img src={statusIcon} className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91]">{t("Status")}</p>
                <p className={`text-[#283D63] ${language == "en" ? "ml-2": "mr-2"}`}>{status}</p>{" "}
              </div>
            </p>
          </div>
          <button onClick={handleChatLinkClick}>
            <img src={done} className="max-lg:w-[90px] max-lg:mx-auto" />
            <p className="text-[#EF8137] underline font-medium max-lg:text-center">
              {t("Chat with support")}
            </p>
          </button>
        </div>

        <div className="flex justify-center my-5">
          <div>
            <button
              onClick={() => showModal("Pricing")}
              className="bg-[#FE9B71] text-white rounded-full px-8 max-lg:px-3 h-10 mx-3"
            >
              {t("Preview order")}
            </button>
            <Modal
              title={t("Order Preview")}
              className="orderModal"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <div className="mt-6">{renderModalContent()}</div>
            </Modal>
          </div>

          <div>
            <button
              onClick={showModalCancel}
              className="text-[#FE9B71] rounded-full h-10 border-2 border-[#FE9B71] px-8 max-lg:px-3"
            >
              {t("Cancel order")}
            </button>

            <Modal
              title={t("Are you sure you want to cancel?")}
              className="orderModal orderModalPricing w_small_modal"
              open={isModalCancel}
              onOk={handleOkCancel}
              onCancel={handleCancelCancel}
              footer={null}
            >
              <form
                className="mx-5 my-5"
                onSubmit={async (e) => {
                  e.preventDefault();

                  if (value) {
                    try {
                      const canceledOrder = await dispatch(
                        updateOrderFunction({
                          status: "cancelled",
                          order_id: idOrder,
                          cancel_reason: value,
                          includeDevice: true,
                        })
                      )
                        .unwrap()
                        .then(() => {
                          window.location.reload();
                          setIsModalCancel(false);
                          message.success("The order cancelled");
                        });
                    } catch (error) {
                      console.error("Error canceling order:", error);
                    }
                  } else {
                    console.error("Please select a cancellation reason.");
                  }
                }}
              >
                <div>
                  <Radio.Group
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                    className="custome_radio custome_radio_color"
                  >
                    <Space direction="vertical">
                      <Radio value="I was trying the app">
                        {t("I was trying the app")}
                      </Radio>
                      <Radio value="I will try ordering this service later">
                        {t("I will try ordering this service later")}
                      </Radio>
                      <Radio value="Appointed technician is not replying">
                        {t("Appointed technician is not replying")}
                      </Radio>
                      <Radio value="No reason">{t("No reason")}</Radio>
                      <Radio value="Other">{t("Other")}</Radio>
                    </Space>
                  </Radio.Group>
                </div>

                <button
                  type="submit"
                  className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
                >
                  {t("Cancel order")}
                </button>
              </form>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceRequest;
